<script>
import { AQUA_FORMS } from './aqua/aquaForms'
import AquaSelect from './aqua/AquaSelect.vue'
import AquaSubjectForms from './aqua/AquaSubjectForms.vue'
import ReportingSection from './ReportingSection.vue'

const FIRST_YEAR = 2020
const DEADLINE_DAY = 10

export default {
	name: 'ReportingPage',
	components: { AquaSelect, AquaSubjectForms, ReportingSection },
	head: {
		title() {
			return {
				inner: this.$t('sidebar.users_parent'),
			}
		},
		meta: [],
	},
	data() {
		return {
			year: new Date().getFullYear() - 1,
			fisheryLinks: [
				// {
				// 	link: '1-rh-mini',
				// 	name: this.$t('reports.subject.px-1-mini'),
				// 	permission: ['read_reporting-1rh'],
				// 	disabled: false,
				// },
				{
					link: '1-rh',
					name: this.$t('reports.subject.px-1'),
					permission: ['read_reporting-1rh'],
				},
				{
					link: '2-rh',
					name: this.$t('reports.subject.px-2'),
					permission: ['read_reporting-2rh'],
					disabled: false,
				},
				{
					link: '3-rh',
					name: this.$t('reports.subject.px-3'),
					permission: ['read_reporting-3rh'],
					disabled: false,
				},
				{
					link: '7-rh',
					name: this.$t('reports.subject.px-7'),
					permission: ['read_reporting-7rh'],
					disabled: false,
				},
				{
					link: '8-rh',
					name: this.$t('reports.subject.px-8'),
					permission: ['read_reporting-8rh'],
					disabled: false,
				},
				{
					link: '9-rh',
					name: this.$t('reports.subject.px-9'),
					permission: ['read_reporting-9rh'],
					disabled: false,
				},
				{
					link: '10-rh',
					name: this.$t('reports.subject.px-10'),
					permission: ['read_reporting-9rh'],
					disabled: false,
				},
				{
					link: '1-tir-rh',
					name: this.$t('reports.tir.px-1'),
					permission: ['read_reporting-1rh-tir'],
				},
				{
					link: '2-tir-rh',
					name: this.$t('reports.tir.px-2'),
					permission: ['read_reporting-2rh-tir'],
					disabled: false,
				},
				{
					link: '3-tir-rh',
					name: this.$t('reports.tir.px-3'),
					permission: ['read_reporting-3rh-tir'],
					disabled: false,
				},
				{
					link: '5-tir-rh',
					name: this.$t('reports.tir.px-5'),
					permission: ['read_reporting-5rh-tir'],
					disabled: false,
				},
				{
					link: '6-tir-rh',
					name: this.$t('reports.tir.px-6'),
					permission: ['read_reporting-6rh-tir'],
					disabled: false,
				},
				{
					link: '7-tir-rh',
					name: this.$t('reports.tir.px-7'),
					permission: ['read_reporting-7rh-tir'],
					disabled: false,
				},
				{
					link: '8-tir-rh',
					name: this.$t('reports.tir.px-8'),
					permission: ['read_reporting-8rh-tir'],
					disabled: false,
				},
				{
					link: '9-tir-rh',
					name: this.$t('reports.tir.px-9'),
					permission: ['read_reporting-9rh-tir'],
					disabled: false,
				},
				{
					link: '10-tir-rh',
					name: this.$t('reports.tir.px-10'),
					permission: ['read_reporting-10rh-tir'],
					disabled: false,
				},
			],
			aquaLinks: [
				...AQUA_FORMS.map((form) => ({
					link: `aqua-tir/${form}`,
					code: `${form}-аква`,
					name: this.$t(`aqua.reporting.forms_short.${form}`),
					permission: ['read_reporting-aqua-tir'],
				})),
				{
					link: 'aqua-tir-compliance',
					code: '',
					name: this.$t('aqua.compliance.title'),
					permission: ['read_reporting-aqua-tir'],
				},
			],
		}
	},
	computed: {
		isAquaSubject() {
			return this.isFeedProducer || this.$store.state.userObject?.subject_kind === 'aquaculture'
		},
		visibleFisheryLinks() {
			return this.fisheryLinks
				.filter((link) => this.$store.getters.userPermission(link.permission))
				.map((link) => this.splitName(link))
		},
		years() {
			const years = []
			for (let year = new Date().getFullYear(); year >= FIRST_YEAR; year--) years.push(year)
			return years
		},
		aquaSubtitle() {
			if (!this.hasSubjectAqua) return this.$t('aqua.reporting.subtitle')
			const date = `${DEADLINE_DAY} ${this.$t('aqua.reporting.january')} ${this.year + 1}`
			return `${this.$t('aqua.reporting.subtitle')} ${this.$t('aqua.reporting.deadline', { date })}`
		},
		visibleAquaLinks() {
			return this.aquaLinks.filter((link) => this.$store.getters.userPermission(link.permission))
		},
		hasSubjectAqua() {
			return this.isAquaSubject && this.$store.getters.userPermission(['read_reporting-aqua'])
		},
		isFeedProducer() {
			return this.$store.state.userObject?.role?.name === 'feed_producer'
		},
		pageSubtitle() {
			const isSubject = this.hasSubjectAqua || this.$store.state.userObject?.role?.name === 'declarer'
			return this.$t(isSubject ? 'aqua.reporting.page_subtitle' : 'aqua.reporting.page_subtitle_review')
		},
	},
	methods: {
		splitName(link) {
			const match = link.name.match(/^(\S+)\s*\((.+)\)$/)
			return match ? { ...link, code: match[1], name: match[2] } : { ...link, code: '' }
		},
		getLink(link) {
			return `/${this.$i18n.locale}/account/reporting/${link}`
		},
	},
	beforeCreate() {
		if (!localStorage.token) this.$router.push('/ru/login')
	},
}
</script>

<template>
	<div class="wrap__content">
		<div class="container">
			<div class="row">
				<div class="col-xl-2 col-lg-3">
					<v-sidebar :active="['ReportingManagement']"></v-sidebar>
				</div>
				<div class="col-xl-10 col-lg-9">
					<div class="content-wrapper">
						<div class="card__content">
							<div class="reporting-head">
								<div>
									<h1 class="reporting-head__title">{{ $t('sidebar.reporting') }}</h1>
									<p class="reporting-head__subtitle">{{ pageSubtitle }}</p>
								</div>
								<AquaSelect
									v-if="hasSubjectAqua"
									v-model="year"
									class="reporting-head__year"
									:label="$t('aqua.reporting.year')"
									:options="years.map((item) => ({ value: item, text: item }))"
								/>
							</div>
							<div class="card__content--body">
								<ReportingSection
									v-if="visibleFisheryLinks.length"
									icon="fish"
									:title="$t('aqua.reporting.fishery_title')"
									:subtitle="$t('aqua.reporting.fishery_subtitle')"
									:default-opened="!hasSubjectAqua"
								>
									<router-link
										v-for="link in visibleFisheryLinks"
										:key="link.link"
										:to="getLink(link.link)"
										class="link-row"
										:class="{ 'is-disabled': link.disabled }"
									>
										<span class="link-row__doc">
											<svg width="20" height="22" viewBox="0 0 20 22" fill="none" stroke="currentColor" stroke-width="1.8">
												<path d="M3 1h10l5 5v15H3z" />
												<path d="M7 10h8M7 14h8M7 18h5" />
											</svg>
										</span>
										<span class="link-row__code">{{ link.code }}</span>
										<span class="link-row__name">{{ link.name }}</span>
										<span class="link-row__open">{{ $t('aqua.reporting.open') }}</span>
									</router-link>
								</ReportingSection>

								<ReportingSection
									v-if="hasSubjectAqua || visibleAquaLinks.length"
									icon="aqua"
									:title="$t('aqua.reporting.title')"
									:subtitle="aquaSubtitle"
								>
									<AquaSubjectForms v-if="hasSubjectAqua" :year="year" :is-feed-producer="isFeedProducer" />
									<router-link
										v-for="link in visibleAquaLinks"
										:key="link.link"
										:to="getLink(link.link)"
										class="link-row"
									>
										<span class="link-row__doc">
											<svg width="20" height="22" viewBox="0 0 20 22" fill="none" stroke="currentColor" stroke-width="1.8">
												<path d="M3 1h10l5 5v15H3z" />
												<path d="M7 10h8M7 14h8M7 18h5" />
											</svg>
										</span>
										<span class="link-row__code">{{ link.code }}</span>
										<span class="link-row__name">{{ link.name }}</span>
										<span class="link-row__open">{{ $t('aqua.reporting.open') }}</span>
									</router-link>
								</ReportingSection>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<style scoped>
.reporting-head {
	display: flex;
	flex-wrap: wrap;
	align-items: flex-end;
	justify-content: space-between;
	gap: 16px;
	margin-bottom: 24px;
}
.reporting-head__title {
	margin: 0 0 6px;
	font-size: 30px;
	font-weight: 700;
	color: #151d48;
}
.reporting-head__subtitle {
	margin: 0;
	color: #6b7a90;
	font-size: 15px;
}
.reporting-head__year {
	width: 220px;
}
.link-row {
	display: grid;
	grid-template-columns: 48px 90px 1fr auto;
	align-items: center;
	gap: 12px;
	padding: 12px 16px;
	margin-bottom: 8px;
	border: 1px solid #edf2f9;
	border-radius: 12px;
	background: #fff;
	color: #151d48;
	transition: box-shadow 0.2s, border-color 0.2s;
}
.link-row:hover {
	border-color: #cfe1f7;
	box-shadow: 0 4px 14px rgba(21, 127, 238, 0.08);
}
.link-row.is-disabled {
	opacity: 0.5;
	pointer-events: none;
}
.link-row__doc {
	display: flex;
	align-items: center;
	justify-content: center;
	width: 44px;
	height: 44px;
	border-radius: 10px;
	background: #eaf3fd;
	color: #157fee;
}
.link-row__code {
	font-weight: 700;
	text-transform: uppercase;
}
.link-row__open {
	padding: 8px 16px;
	border: 1px solid #c9d6e6;
	border-radius: 10px;
	font-weight: 500;
	white-space: nowrap;
}
.link-row:hover .link-row__open {
	border-color: #157fee;
	color: #157fee;
}
@media (max-width: 768px) {
	.link-row {
		grid-template-columns: 44px 1fr;
	}
	.link-row__name,
	.link-row__open {
		grid-column: 2;
	}
}
</style>
